import { render, staticRenderFns } from "./Movimiento.vue?vue&type=template&id=c4a76600&scoped=true"
import script from "./Movimiento.vue?vue&type=script&lang=js"
export * from "./Movimiento.vue?vue&type=script&lang=js"
import style0 from "./Movimiento.vue?vue&type=style&index=0&id=c4a76600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a76600",
  null
  
)

export default component.exports